module.exports = __webpack_public_path__ + "static/media/helium_logo.b0a2aca4.png";